import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import FileSaver from 'file-saver';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

const httpOptionData = {
  headers: new HttpHeaders({
    // 'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class HorarioService {
  url = environment.baseUrl + '/api/Horario';

  constructor(private http: HttpClient) {}

  getHorarios(
    page: number,
    numReg: number,
    searchString: string,
    disciplinaId?: string
  ): Observable<any> {
    const body = { page, numReg, searchString, disciplinaId };
    console.log('el cuerpo es: ', body);
    return this.http.post<any>(this.url + '/GetHorarios', body, httpOption);
  }

  getHorariosAdmin(
    page: number,
    numReg: number,
    searchString: string,
    empresaId: string,
    piscina: number,
    disciplinaId?: string
  ): Observable<any> {
    const body = {
      page,
      numReg,
      searchString,
      empresaId,
      piscina,
      disciplinaId,
    };
    console.log('el cuerpo es: ', body);
    return this.http.post<any>(
      this.url + '/GetHorariosAdmin',
      body,
      httpOption
    );
  }

  getHorariosDropdown(id: string): Observable<any> {
    // este id es la disciplina
    const body = { id };
    return this.http.post<any>(
      this.url + '/GetHorariosDropdown',
      body,
      httpOption
    );
  }

  addHorario(obj: any): Observable<boolean> {
    console.log('horario crear: ', obj);
    // const body = { page, numReg, searchString };
    return this.http.post<boolean>(this.url + '/AddHorario', obj, httpOption);
  }

  getHorario(id: string): Observable<any> {
    // const body = { page, numReg, searchString };
    return this.http.post<any>(this.url + '/GetHorario', { id }, httpOption);
  }

  editHorario(obj: any): Observable<boolean> {
    // const body = { page, numReg, searchString };
    return this.http.post<boolean>(this.url + '/EditHorario', obj, httpOption);
  }

  deleteHorario(id: string): Observable<boolean> {
    // const body = { page, numReg, searchString };
    return this.http.post<boolean>(
      this.url + '/DeleteHorario',
      { id },
      httpOption
    );
  }

  updateEstadoHorario(id: string, estado: boolean): Observable<boolean> {
    // const body = { page, numReg, searchString };
    return this.http.post<boolean>(
      this.url + '/UpdateEstadoHorario',
      { id, estado },
      httpOption
    );
  }

  getHorariosUsuarioYDisponibles(obj: any): Observable<any> {
    // const body = { page, numReg, searchString };
    return this.http.post<any>(
      this.url + '/GetHorariosUsuarioYDisponibles',
      obj,
      httpOption
    );
  }

  editarUsuarioHorario(
    usuarioId: string,
    horarioId: string,
    activar: boolean
  ): Observable<boolean> {
    // const body = { page, numReg, searchString };
    return this.http.post<boolean>(
      this.url + '/EditarUsuarioHorario',
      { usuarioId, horarioId, activar },
      httpOption
    );
  }

  getDeportistasHorario(id: string): Observable<any> {
    // const body = { page, numReg, searchString };
    return this.http.post<any>(
      this.url + '/GetDeportistasHorario',
      { id },
      httpOption
    );
  }

  downloadDeportistasHorario(id: string):Observable<Blob> {
    return this.http.post<Blob>(this.url+'/DownloadDeportistasHorario',{id}, {responseType: 'blob' as 'json'});
  }

  downloadFullDeportistasHorario():Observable<Blob> {
    return this.http.post<Blob>(this.url+'/DownloadFullDeportistasHorario',{}, {responseType: 'blob' as 'json'});
  }

  


}
